import React, {useContext, useRef} from 'react';
import Context from '../OriginStoryProvider';
import { useGSAP } from '@gsap/react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const Stats = () => {
	const { data: {content} } = useContext(Context);

	const statsContainer = useRef(null);
	let tl = useRef(null);

	useGSAP(() => {
		const years = gsap.utils.toArray('.chapter-2__stats__years-item');
		const faculty = gsap.utils.toArray('.chapter-2__stats__numbers--faculty');
		const students = gsap.utils.toArray('.chapter-2__stats__numbers--students');

		tl = gsap.timeline({paused: true})
			.from('.chapter-2__stats__years-item', {
				opacity: (index) => {
					if (index === 0) {
						return;
					} else {
						return 0;
					}
				},
				stagger: 0.3,
			})
			.to('.chapter-2__stats__years-item', {
				opacity: (index) => {
					if (index === (years.length - 1)) {
						return;
					} else {
						return 0;
					}
				},
				stagger: 0.3,
				delay: 0.15,
			}, '<0.15')
			.to(faculty, {
				innerText: content.chapters.second.stats.faculty.max,
				snap: {
					innerText: 1,
				},
				duration: 6,
			}, '<')
			.to(students, {
				innerText: content.chapters.second.stats.students.max,
				snap: {
					innerText: 1,
				},
				duration: 6,
			}, '<')
			
		ScrollTrigger.create({
			trigger: statsContainer.current,
			start: 'center bottom',
			toggleActions: 'none reset none reset',
			animation: tl
		});
	}, {scope: statsContainer.current, dependencies: [content.chapters]});

	const renderYears = () => {
		const years = content.chapters.second.stats.years;
		
		if (years.length === 0) return null;

		return (
			<ul className='chapter-2__stats__years-list'>
				{
					years.map(year => {
						return (
							<li key={year} className='chapter-2__stats__years-item'>
								<p className='chapter-2__stats__year'>{year}</p>
							</li>
						)
					})
				}
			</ul>
		)
	}

	const handleClick = () => {
		tl.restart();
	}

	return (
		<div className='chapter-2__stats main-grid' ref={statsContainer}>
			<div className='main-grid__margin'></div>
			<div className='main-grid__body'>
				<div className='chapter-2__stats__button__container'>
					<button 
						className='chapter-2__stats__button'
						type='button' 
						aria-label='play animation'
						onClick={handleClick}
					><p className='chapter-2__stats__title'>{content.chapters.second.stats.title}</p></button>
					
				</div>
				<div className='chapter-2__stats__container'>
					<div className='chapter-2__stats__year-wrapper'>
						{renderYears()}
						<img className='chapter-2__stats__bg-shape' src={`${mainScript.assetPath}images/svg/graphics/bg-shape--yellow-circle.svg`} loading="lazy" alt=""/>
					</div>
					<div className='chapter-2__stats__wrapper'>
						<p className='chapter-2__stats__numbers chapter-2__stats__numbers--faculty h1'>{content.chapters.second.stats.faculty.min}</p>
						<p className='chapter-2__stats__category img-caption'>faculty</p>
					</div>
					<div className='chapter-2__stats__wrapper'>
						<p className='chapter-2__stats__numbers chapter-2__stats__numbers--students h1'>{content.chapters.second.stats.students.min}</p>
						<p className='chapter-2__stats__category img-caption'>total number of students</p>
					</div>
				</div>
			</div>
			<div className='main-grid__margin'></div>
		</div>
	)
}

export default Stats;